// extracted by mini-css-extract-plugin
export default {"container":"HW-z","title":"IW-z","link":"JW-z"};